export { AgeGate } from './Age';
